import { defineMessages } from 'react-intl'

export default defineMessages({
  add: {
    id: 'Add',
    defaultMessage: 'Add'
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel'
  },
  deleting: {
    id: 'Deleting',
    defaultMessage: 'Deleting...'
  },
  developerGuide: {
    id: 'SpaceCustomAppEditPage.AddAppDescription.AppDeveloperGuide',
    defaultMessage: 'App Developer Guide'
  },
  install: {
    id: 'Install',
    defaultMessage: 'Install'
  },
  noSettingsInfo: {
    id: 'SpaceAppsPage.AppCatalog.Details.NoSettingsInfo',
    defaultMessage: 'No Settings Information is available for this app'
  },
  overview: {
    id: 'SpaceAppsPage.AppCatalog.Details.Overview',
    defaultMessage: 'Overview'
  },
  saving: {
    id: 'Saving',
    defaultMessage: 'Saving...'
  },
  settingsInfo: {
    id: 'SpaceAppsPage.AppCatalog.Details.SettingsInfo',
    defaultMessage: 'Settings Info'
  },
  smartNotifications: {
    id: 'SpaceCustomAppEditPage.CustomAppEditForm.Connector.SmartNotifications',
    defaultMessage: 'Smart Notifications'
  },
  unableToLoad: {
    id: 'SpaceAppsPage.AppCatalog.Details.ErrorMessage',
    defaultMessage: 'Sorry we were unable to load this app detail at this time. Please try again later!'
  },
  unableToLoadHeader: {
    id: 'SpaceAppsPage.AppCatalog.Details.UnableToLoadHeader',
    defaultMessage: 'Unable to load app details'
  }
})
